import { useState } from "react";
import AscAdminAction from "../AscAdminAction/AscAdminAction";
import { MoreIcon } from "../AscIcons";
import AscModalDelete from "../AscModalDelete/AscModalDelete";

import styles from "./AscBatchesCard.module.scss";
import { useOutsideClick } from "@ascendnow/shared";

export interface AscBatchesCardProps {
  title: string;
  image?: string;
  onClick?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

export default function AscBatchesCard({
  image,
  title,
  onClick,
  onEdit,
  onDelete,
}: AscBatchesCardProps) {
  const { ref, isVisible, setIsVisible } =
    useOutsideClick<HTMLDivElement>(false);
  const [deleteModal, setDeleteModal] = useState(false);

  return (
    <div
      className={styles.container}
      onClick={({ target }) => {
        if (ref?.current && !ref?.current.contains(target as Node)) {
          onClick?.();
        }
      }}
    >
      {!image ? (
        <div className={styles.noImage} />
      ) : (
        <img src={image || ""} alt="batch-bg" />
      )}
      <div className={styles.bottom}>
        <div className={styles.title}>{title}</div>

        <div ref={ref}>
          <MoreIcon
            className={styles.icon}
            onClick={() => setIsVisible(!isVisible)}
          />

          {isVisible && (
            <AscAdminAction
              option1={"Edit"}
              option2={"Remove"}
              clickOption1={onEdit}
              clickOption2={() => setDeleteModal(true)}
              className={styles.actionBar}
            />
          )}
        </div>
      </div>
      {deleteModal && onDelete && (
        <AscModalDelete
          title="Are you sure you want to delete the batch?"
          visible={deleteModal}
          setVisible={setDeleteModal}
          onApprove={onDelete}
        />
      )}
    </div>
  );
}
